import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { StrapiVideoProps } from '../section/interfaces';
import { MRVideo } from './VideoCard';

interface Props {
  props: Partial<StrapiVideoProps>;
  className?: string;
  children?: ReactNode;
}

export const VideoPlayer: FC<Props> = ({
  props: {
    variantButton = 'blue',
    play = false,
    loop = false,
    url,
    size = 'lg',
    allowUnmute = false,
    autoPlayOnView = false,
  },
  className,
}) => {
  const id = 'feature-video';

  return (
    <div className={twMerge('mrc-info-card-banner flex', className)}>
      <div className='product-feature-video-container mx-auto w-full max-w-screen-2xl px-5 md:px-16 xl:px-[7.5rem]'>
        <MRVideo
          variantButton={variantButton}
          play={play}
          loop={loop}
          id={id}
          url={String(url)}
          size={size}
          allowUnmute={allowUnmute}
          autoPlayOnView={autoPlayOnView}
        />
      </div>
    </div>
  );
};
